import React from 'react';
import { Section } from './ui/Section';
export function StorySection() {
  return <Section id="why-seven" background="night-800" className="relative overflow-hidden" data-id="element-165">
      {/* Subtle warm tint overlay */}
      <div className="absolute inset-0 bg-gold-500/5 pointer-events-none" data-id="element-166" />

      <div className="relative z-10" data-id="element-167">
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-8 text-center" data-id="element-168">
          Why Is This Only $7?
        </h2>

        <div className="prose prose-lg prose-invert mx-auto text-slate-300" data-id="element-169">
          <p className="mb-6" data-id="element-170">I've been exactly where you are right now.</p>

          <p className="mb-6" data-id="element-171">
            Five years ago, I was spending hundreds of dollars on supplements,
            trying every sleep routine I could find, rotating through
            specialists who each had a different theory. Nothing worked for more
            than a few weeks.
          </p>

          <p className="mb-6 font-medium text-white" data-id="element-172">
            Until I realized I was treating branches instead of pulling roots.
          </p>

          <p className="mb-6" data-id="element-173">
            The insight that changed everything for me wasn't complicated. It
            wasn't a $2,000 sleep study or a prescription. It was understanding
            that my insomnia, my afternoon crashes, my Sunday anxiety, and my
            coffee dependency were all branches of ONE structural root I'd never
            been asked to look at.
          </p>

          <p className="mb-6" data-id="element-174">
            Once I identified that root, everything shifted. Not overnight, but
            it shifted.
          </p>

          <p className="mb-6" data-id="element-175">
            I created this audio because I know how exhausting it is to keep
            trying solutions that stop working. And I don't want price to be the
            reason someone doesn't hear this perspective.
          </p>

          <p className="mb-8" data-id="element-176">
            If charging $7 means 10x more people actually listen and stop
            wasting time on shallow fixes, that's worth it to me.
          </p>

          <p className="font-serif text-2xl text-gold-500 italic text-center my-10" data-id="element-177">
            This isn't a business model. It's a mission.
          </p>

          <p className="mb-0 text-center" data-id="element-178">
            I want as many people as possible to understand what's actually
            happening with their insomnia, so they can stop cutting branches and
            start pulling roots.
          </p>
        </div>
      </div>
    </Section>;
}